import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { Container, Card, Form, Button, Row, Col, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { serverHost } from "variables/serverdata";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { Input } from "reactstrap";

const CallblockAddEdit = ({ method }) => {
  const edit = method === "edit";
  const navigate = useNavigate();
  const { id } = useParams();
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const [formData, setFormData] = useState({
    direction: "inbound",
    extension: null,
    name: null,
    countryCode: null,
    callerIdNumber: null,
    action: "reject",
    domain: "",
    enabled: true,
    description: null,
  });

  const directionOptions = [
    { value: "inbound", label: "Inbound" },
    { value: "outbound", label: "Outbound" },
  ];

  const [extensionOptions, setExtensionOptions] = useState([
    { value: null, label: "All" },
  ]);
  const [voicemailList, setVoicemailList] = useState([]);
  const [ivrList, setIVRList] = useState([]);
  const [ringGroupList, setRingGroups] = useState([]);
  const [actionOptions, setActionOptions] = useState([
    { value: "reject", label: "Reject" },
    { value: "busy", label: "Busy" },
    { value: "hold", label: "Hold" },
  ]);

  // Inbound call history (only shown in "add" mode, so the user can pick a
  // caller to block directly from a recent call rather than typing it in)
  const [allCalls, setAllCalls] = useState([]);
  const [callsLoading, setCallsLoading] = useState(false);
  const [callsError, setCallsError] = useState("");
  const [callDirectionFilter, setCallDirectionFilter] = useState("inbound");

  const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
  const domain_uuid = currentSite?.domain_uuid || null;
  const site_uuid = currentSite?.site_uuid || null;
  const [error, setError] = useState();
  const [loading, setLoading] = useState([]);
  useEffect(() => {
    const fetchDomain = async (e) => {
      try {
        const response = await fetch(
          `${serverHost}/fetch_domain_name/${site_uuid}`,
        );
        if (!response.ok) throw new Error(`Failed to fetch domain context`);
        const data = await response.json();
        setFormData((prev) => ({ ...prev, domain: data.result }));
      } catch (err) {
        setError(err.message);
      }
    };

    const fetchExtensions = async () => {
      console.log(domain_uuid);
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_extensions&pageSize=50&page=1&domain_uuid=${encodeURIComponent(domain_uuid)}`,
        );
        if (res.ok) {
          const data = await res.json();
          const extensions = data.results.map((e) => ({
            value: e.extension_uuid,
            label: e.extension,
          }));
          console.log("extensions: ", extensions);
          setExtensionOptions((prev) => {
            const merged = [...prev, ...extensions];
            const unique = Array.from(
              new Map(merged.map((item) => [item.value, item])).values(),
            );
            return unique;
          });
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };

    const fetchIVR = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_ivr_menus&pageSize=50&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const ivrs = data.results.map((i) => ({
            value: `ivr:${i.ivr_menu_extension}`,
            label: `${i.ivr_menu_name}`,
          }));
          console.log(ivrs);
          setIVRList(ivrs);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchRingGroups = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_ring_groups&pageSize=50&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const ringgroups = data.results.map((r) => ({
            value: `ring_group:${r.ring_group_extension}`,
            label: `${r.ring_group_name}`,
          }));
          console.log(ringgroups);
          setRingGroups(ringgroups);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchVoicemails = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_voicemails&pageSize=50&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const voicemails = data.results.map((r) => ({
            label: r.voicemail_id,
            value: `voicemail:${r.voicemail_id}`,
          }));
          console.log("Voicemails:", voicemails);
          setVoicemailList(voicemails);
        }
      } catch (err) {
        console.error("Failed to fetch voicemails:", err);
      }
    };
    const fetchCallblock = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_row?table=v_call_block&pk=call_block_uuid&id=${encodeURIComponent(id)}`,
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Row not found" : "Failed to fetch row",
          );
        const data = await res.json();
        if (!data?.result) throw new Error("Row not found");
        const callblock = data.result;
        console.log(data.result);
        setFormData({
          direction: data.result.call_block_direction,
          extension: data.result.extension_uuid,
          name: data.result.call_block_name,
          countryCode: data.result.call_block_country_code,
          callerIdNumber: data.result.call_block_number,
          action: `${data.result.call_block_app}${data.result.call_block_data ? `:${data.result.call_block_data}` : ""}`,
          domain: data.result.call_block_domain_uuid,
          enabled: data.result.call_block_enabled,
          description: data.result.call_block_description,
        });
      } catch (err) {
        console.log("Error fetching callblock data, ", err);
      }
    };

    // NOTE: adjust table/column names here to match your CDR backend if they differ.
    // Fetches both directions; the dropdown in the UI filters client-side so
    // switching between inbound/outbound doesn't require a refetch.
    const fetchCalls = async () => {
      setCallsLoading(true);
      setCallsError("");
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_xml_cdr&pageSize=50&page=1&domain_uuid=${encodeURIComponent(site_uuid)}&sort=start_stamp&order=desc`,
        );
        if (!res.ok) throw new Error("Failed to fetch calls");
        const data = await res.json();
        const calls = (data.results || []).map((c) => ({
          uuid: c.xml_cdr_uuid,
          direction: c.direction,
          callerIdName: c.caller_id_name,
          callerIdNumber: c.caller_id_number,
          destination: c.destination_number,
          startStamp: c.start_stamp,
        }));
        setAllCalls(calls);
      } catch (err) {
        console.error("Failed to fetch calls:", err);
        setCallsError(err.message);
      } finally {
        setCallsLoading(false);
      }
    };

    const loadData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchDomain(),
          fetchExtensions(),
          fetchIVR(),
          fetchRingGroups(),
          fetchVoicemails(),
          edit ? fetchCallblock() : fetchDomain(),
          edit ? Promise.resolve() : fetchCalls(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Pre-fills the block form from a row in the inbound call history table
  const handleBlockCall = (call) => {
    setFormData((prev) => ({
      ...prev,
      direction: call.direction || prev.direction,
      callerIdNumber: call.callerIdNumber,
      name: call.callerIdName || prev.name,
    }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const displayedCalls = allCalls.filter(
    (call) => call.direction === callDirectionFilter,
  );

  const formatCallDate = (stamp) => {
    if (!stamp) return "";
    const d = new Date(stamp);
    return isNaN(d.getTime()) ? stamp : d.toLocaleString();
  };

  const handleSubmit = async (e) => {
    console.log("Form submitted:", formData);
    // Add your API call here
    setError("");

    try {
      const site = JSON.parse(localStorage.getItem("selectedSite"));

      const payload = {
        data: {
          ...formData,
        },
        client_uuid: site.client_uuid,
        site_name: site.company_name,
        insert_uuid: JSON.parse(localStorage.getItem("user")).user_uuid,
      };
      let url = `${serverHost}/callblock/${site.site_uuid}`;
      if (edit) {
        url = `${serverHost}/update_callblock/${id}`;
        payload.site_uuid = site.site_uuid;
      }
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let fail = "";
        console.log("Failing to insert, ", res.ok);
        if (res.status === 403) fail = "; Limit reached";
        throw new Error("Failed to insert record" + fail);
      }

      navigate("/admin/hucs/call-blocks");
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
  };

  const handleCancel = () => {
    navigate("/admin/hucs/call-blocks"); // Go back to previous page
  };

  if (loading) {
    return (
      <>
        <SimpleHeader name="Edit Inbound Route" parentName="HUCS" />
        <Container className="mt--6">
          <Card className="shadow-sm" style={{ marginTop: "-3rem" }}>
            <Card.Body className="p-4 text-center">
              <p>Loading...</p>
            </Card.Body>
          </Card>
        </Container>
      </>
    );
  }

  return (
    <>
      <SimpleHeader
        name={`${method.toUpperCase()} Call Block`}
        parentName="HUCS"
      />
      <Container fluid className="mt--6">
        <Card className="shadow-sm" style={{ border: "none" }}>
          <Card.Header
            style={{
              backgroundColor: isDark ? "#1f2937" : "#e9ecef",
              color: isDark ? "#e2e8f0" : "#1e3a5f",
              borderBottom: "none",
              padding: "1rem 1.5rem",
            }}
          >
            <h5 className="mb-0" style={{ fontWeight: 600 }}>
              {method.toUpperCase()} CALL BLOCK
            </h5>
          </Card.Header>

          <Card.Body
            style={{
              backgroundColor: isDark ? "#1f2937" : "#fff",
              padding: "1.5rem",
            }}
          >
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                {/* Direction */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Direction
                    </Form.Label>
                    <Input
                      type="select"
                      name="direction"
                      value={formData.direction}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      {directionOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Input>
                  </Form.Group>
                </Col>

                {/* Extension */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Extension
                    </Form.Label>
                    <Input
                      type="select"
                      name="extension"
                      value={formData.extension}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      {extensionOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Input>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Name */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter name"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* Country Code */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Country Code
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      placeholder="e.g., +1"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* Caller ID Number */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Caller ID Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="callerIdNumber"
                      value={formData.callerIdNumber}
                      onChange={handleChange}
                      placeholder="Enter caller ID number"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Action */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Action
                    </Form.Label>
                    <Input
                      type="select"
                      name="action"
                      value={formData.action}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      {actionOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                      <optgroup label="Extensions">
                        {extensionOptions.map((opt) => (
                          <option
                            key={opt.value}
                            value={`extension:${opt.value}`}
                          >
                            {opt.label}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="IVRs">
                        {ivrList.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Ring Groups">
                        {ringGroupList.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Voicemail">
                        {voicemailList.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </optgroup>
                    </Input>
                  </Form.Group>
                </Col>

                {/* Domain */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Domain
                    </Form.Label>
                    <Input
                      type="text"
                      name="domain"
                      value={formData.domain}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#000000ff" : "#beb6b6ff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                      disabled
                    ></Input>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Enabled Toggle */}
                <Col md={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <span style={{ color: isDark ? "#e2e8f0" : "#495057" }}>
                      Enabled
                    </span>

                    <label className="custom-toggle mb-0">
                      <input
                        type="checkbox"
                        id="enabled"
                        name="enabled"
                        checked={formData.enabled}
                        onChange={handleChange}
                      />
                      <span
                        className="custom-toggle-slider rounded-circle"
                        data-label-off="Off"
                        data-label-on="On"
                      />
                    </label>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Description */}
                <Col md={12}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Enter description"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Action Buttons */}
              <div className="d-flex justify-content-between mt-4">
                <Button variant="danger" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button variant="success" onClick={handleSubmit}>
                  {method.toUpperCase()} Call Block
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>

        {/* Inbound call history — lets the user block a caller with one click.
            Only shown when adding a new block (not when editing an existing one). */}
        {!edit && (
          <Card className="shadow-sm mt-4" style={{ border: "none" }}>
            <Card.Header
              style={{
                backgroundColor: isDark ? "#1f2937" : "#e9ecef",
                color: isDark ? "#e2e8f0" : "#1e3a5f",
                borderBottom: "none",
                padding: "1rem 1.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "0.75rem",
              }}
            >
              <h5 className="mb-0" style={{ fontWeight: 600 }}>
                RECENT CALLS
              </h5>
              <Input
                type="select"
                value={callDirectionFilter}
                onChange={(e) => setCallDirectionFilter(e.target.value)}
                style={{
                  width: "auto",
                  backgroundColor: isDark ? "#374151" : "#fff",
                  color: isDark ? "#e2e8f0" : "#495057",
                  borderColor: isDark ? "#4b5563" : "#ced4da",
                }}
              >
                <option value="inbound">Inbound</option>
                <option value="outbound">Outbound</option>
              </Input>
            </Card.Header>
            <Card.Body
              style={{
                backgroundColor: isDark ? "#1f2937" : "#fff",
                padding: "1.5rem",
              }}
            >
              {callsLoading ? (
                <p className="mb-0">Loading calls...</p>
              ) : callsError ? (
                <p className="mb-0 text-danger">{callsError}</p>
              ) : displayedCalls.length === 0 ? (
                <p className="mb-0">
                  No recent {callDirectionFilter} calls found.
                </p>
              ) : (
                <Table
                  responsive
                  hover
                  className="mb-0"
                  variant={isDark ? "dark" : undefined}
                >
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Caller ID Name</th>
                      <th>Caller ID Number</th>
                      <th>Destination</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedCalls.map((call) => (
                      <tr key={call.uuid}>
                        <td>{formatCallDate(call.startStamp)}</td>
                        <td>{call.callerIdName || "—"}</td>
                        <td>{call.callerIdNumber || "—"}</td>
                        <td>{call.destination || "—"}</td>
                        <td className="text-end">
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => handleBlockCall(call)}
                          >
                            Block
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        )}
      </Container>
    </>
  );
};

export default CallblockAddEdit;